import { render, staticRenderFns } from "./relatedSeries.vue?vue&type=template&id=6c263910&scoped=true"
import script from "./relatedSeries.vue?vue&type=script&lang=js"
export * from "./relatedSeries.vue?vue&type=script&lang=js"
import style0 from "./relatedSeries.vue?vue&type=style&index=0&id=6c263910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c263910",
  null
  
)

export default component.exports